import { gql } from '@apollo/client'
import PropTypes from 'prop-types'
import money, { moneyPropTypes } from '~/graphql/fragments/money'

export const listingListFragment = gql`
  fragment listingList on PublicListing {
    id
    hash
    description
    isPublic
    status
    event {
      id
      name
      startDate
      endDate
      slug
      status
      location {
        id
        name
        city {
          id
          name
        }
      }
    }
    eventType {
      id
      title
      startDate
      endDate
    }
    seller {
      id
      firstname
      avatar
    }
    tickets(first: 99) {
      edges {
        node {
          id
          status
        }
      }
    }
    numberOfTicketsInListing
    numberOfTicketsStillForSale
    price {
      totalPriceWithTransactionFee {
        ...money
      }
      sellerPrice {
        ...money
      }
    }
  }

  ${money}
`

export const listingListFragmentPropTypes = PropTypes.shape({
  id: PropTypes.string.isRequired,
  hash: PropTypes.string,
  description: PropTypes.string,
  isPublic: PropTypes.bool,
  status: PropTypes.oneOf(['AVAILABLE', 'DELETED', 'RESERVED', 'SOLD']).isRequired,
  event: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    status: PropTypes.oneOf(['ACTIVE', 'CANCELLED', 'EXPIRED']).isRequired,
    startDate: PropTypes.string.isRequired,
    endDate: PropTypes.string,
    location: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      city: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
      }),
    }),
  }).isRequired,
  eventType: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    startDate: PropTypes.string.isRequired,
    endDate: PropTypes.string,
  }),
  seller: PropTypes.shape({
    id: PropTypes.string.isRequired,
    firstname: PropTypes.string,
    avatar: PropTypes.string,
  }),
  numberOfTicketsInListing: PropTypes.number.isRequired,
  numberOfTicketsStillForSale: PropTypes.number.isRequired,
  price: PropTypes.shape({
    totalPriceWithTransactionFee: moneyPropTypes.isRequired,
    sellerPrice: moneyPropTypes.isRequired,
  }).isRequired,
  tickets: PropTypes.shape({
    edges: PropTypes.arrayOf(
      PropTypes.shape({
        node: PropTypes.shape({
          id: PropTypes.string.isRequired,
          status: PropTypes.oneOf(['AVAILABLE', 'SOLD', 'RESERVED', 'LOCKED']),
        }),
      })
    ),
  }),
})
